/**
 * Humanize a meetup RPC error for an admin toast. Same style as
 * ../groups/adminErrors.ts (message-key → human text) — kept as its own
 * small table rather than merged into that one, since the RAISE EXCEPTION
 * keys this page can actually trigger (backend/supabase/migrations/
 * 20260930120500_groups_meetups_rpcs.sql's cancel_meetup) only partially
 * overlap the groups page's.
 */
const GROUP_MEETUPS_ADMIN_ERROR_COPY: Record<string, string> = {
  meetup_not_found: "This meetup couldn't be found.",
  not_allowed: "You don't have permission to do that.",
  groups_disabled: 'Groups are turned off — enable them on the Groups Settings page first.',
  not_authenticated: 'Your session has expired — sign in again.',
};

export function groupMeetupsAdminErrorMessage(error: unknown): string {
  const message =
    typeof error === 'object' && error !== null && 'message' in error
      ? String((error as { message: unknown }).message)
      : String(error);
  return GROUP_MEETUPS_ADMIN_ERROR_COPY[message] ?? message;
}
